import { Link } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";
import { Download } from "lucide-react";
import { useCatalogue, displayName } from "./useCatalogue";
import { waLink, PHONE, PHONE_LINK, EMAIL, ADDRESS, CATALOGUE_URL, CATALOGUE_SIZE } from "../seo";

export default function Footer() {
  const { categories } = useCatalogue();
  return (
    <>
      <footer className="footer" data-testid="footer">
        <div className="footer-grid">
          <div className="footer-col">
            <p className="footer-kicker">Sepla · Raj Enterprises</p>
            <p className="footer-line">Stainless steel hotelware manufacturer in Mumbai, crafting steel for over 30 years. Supplying hotels and caterers across India.</p>
            <a href={CATALOGUE_URL} download className="btn btn-accent footer-catalogue" data-testid="footer-download-catalogue"><Download size={14} /> Download catalogue</a>
            <p className="footer-catalogue-meta">{CATALOGUE_SIZE}</p>
          </div>
          <div className="footer-col">
            <p className="footer-head">Categories</p>
            {categories.map((c) => (
              <Link key={c.slug} to={`/category/${c.slug}`} className="footer-link">{displayName(c.name)}</Link>
            ))}
          </div>
          <div className="footer-col">
            <p className="footer-head">Company</p>
            <Link to="/about" className="footer-link">About</Link>
            <Link to="/custom-oem" className="footer-link">Custom &amp; OEM</Link>
            <Link to="/product-index" className="footer-link">Product Index</Link>
            <Link to="/contact" className="footer-link">Contact</Link>
          </div>
          <div className="footer-col">
            <p className="footer-head">Contact</p>
            <a className="footer-link" href={PHONE_LINK}>{PHONE}</a>
            <a className="footer-link" href={`mailto:${EMAIL}`}>{EMAIL}</a>
            <p className="footer-addr">{ADDRESS}</p>
          </div>
        </div>
        <div className="footer-legal">
          <p>All pictures, specifications and other content are the property of Sepla. Product images and specifications are indicative; Sepla may change or modify products without prior notice.</p>
        </div>
        <div className="footer-word" aria-hidden="true">SEPLA</div>
      </footer>

      <a
        className="wa-float"
        href={waLink("Hi Sepla, I'd like to know more about your hotelware range.")}
        target="_blank" rel="noreferrer"
        aria-label="Chat on WhatsApp"
        data-testid="whatsapp-float"
      >
        <FaWhatsapp size={24} />
      </a>
    </>
  );
}
